<template>
  <div class="container">
    <h4 class="title is-4">{{collectionName}}</h4>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <router-link :to="{path: '/tools/requester'}">Requester</router-link>
              </li>
              <li class="is-active" aria-current="page">
                <span style="margin-left: 0.75rem;">
                  {{collectionName}}
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div class="container has-text-left">
      <template v-if="collection.requests.length > 0">
        <b-table
            :striped="true"
            :narrowed="true"
            :data="requests"
        >
          <template slot-scope="props">
            <b-table-column field="num" numeric>{{props.row.num}}</b-table-column>
            <b-table-column label="Name" field="name">
              <router-link :to="{name: 'Request', params: {id: props.row.id}}">{{props.row.name}}</router-link>
            </b-table-column>
            <b-table-column label="Call Name" field="callName">{{props.row.callName}}</b-table-column>
            <b-table-column label="Operations" numeric>-</b-table-column>
          </template>
        </b-table>
      </template>
      <template v-else>
        <p>No requests in this collection.
          <router-link :to="{name: 'Request', params: {collectionId: id}}">Add Request.</router-link>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      BTable,
    },
    name: "screenrequestercollection",
    props: ['id'],
    data() {
      return {};
    },
    computed: {
      ...mapGetters('requester', ['collectionById']),
      collection() {
        return this.collectionById(this.id);
      },
      collectionName() {
        if (!this.collection) {
          return 'Collection';
        }

        return `${this.collection.name} Collection`;
      },
      requests() {
        if (!this.collection) {
          return [];
        }

        let num = 0;
        return this.collection.requests.map(item => {
          const content = JSON.parse(item.content);
          const { url, method } = content;
          num++;
          const callName = `${method} ${url}`;
          return {
            ...item,
            callName,
            num
          };
        });
      }
    },
    methods: {
      ...mapActions('requester', ['saveRequest'])
    },
    mounted() {
    },
    unmounted() {
    }
  }
</script>

<style scoped>

</style>